module.exports = __webpack_public_path__ + "static/media/banner-catalog.c13f307f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner-catalog.png
// module id = 92
// module chunks = 0